import {Component, OnDestroy, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    TemplateComponent
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit, OnDestroy {

  date: string = '-';
  interval = 0;

  constructor() {
  }

  ngOnInit() {
    this.updateDate();

    this.interval = setInterval(() => {
      this.updateDate();
    }, 1000);
  }

  ngOnDestroy() {
    if (this.interval) clearInterval(this.interval);
  }

  format(time: number) {
    return ('0' + time).slice(-2);
  }

  updateDate() {
    const dt = new Date();
    this.date = `${this.format(dt.getUTCDate())}.${this.format(dt.getUTCMonth() + 1)}.${dt.getUTCFullYear()}
      ${this.format(dt.getUTCHours())}:${this.format(dt.getUTCMinutes())}:${this.format(dt.getUTCSeconds())}`;
  }
}
